import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const AGENCY_LIST = gql`
  query agencyList($filter: AgencyFilter) {
    agencyList(filter: $filter) {
      total
      data {
        id
        name
        type
        isDefault
        projectAgencies {
          projectName
          creator
          createdAt
        }
      }
    }
  }
`;

export const GET_AGENCY_CONTACTS = gql`
  query agencyUserList($filter: UsersListFilter!) {
    agencyUserList(filter: $filter) {
      total
      data {
        id
        name
        countryCode
        designation
        isActive
        phoneNo
        email
      }
    }
  }
`;

export const GET_AGENCY_USER_SINGLE_ASSIGNMENTS = gql`
  query AgencyUserSingleAssignments(
    $where: AgencyUserInput!
    $filter: CommonFilter!
  ) {
    agencyUserSingleAssignments(where: $where, filter: $filter) {
      total
      data {
        id
        userName
        projectName
        eqcTypeName
        stageName
        levelNumber
        levelName
      }
    }
  }
`;

export const GET_AGENCY_SINGLE_ASSIGNMENTS = gql`
  query agencySingleAssignments($where: AgencyInput!, $filter: CommonFilter!) {
    agencySingleAssignments(where: $where, filter: $filter) {
      total
      data {
        id
        userName
        projectName
        eqcTypeName
        stageName
        levelNumber
        levelName
      }
    }
  }
`;
